export const notifications = {
  update_group_error: 'There was an error updating your Community Groups.',
  update_group_success: 'Your Community Groups have been updated!',
} as const;

export type NotificationsNamespace = Record<keyof typeof notifications, string>;
